import React, { createContext } from 'react';
import {
  Application,
  ISalesforceService,
  ApplicationAction,
  Catalogue,
  IFeesService,
} from '../../common';
import { IBankDetailsValidationService } from '../../common/services/bank-details-validation-service';
import { IOnboardingTealiumService } from 'src/services/tealium/onboarding/onboarding-tealium-service';
import { IDeviceActivationTealiumService } from 'src/services/tealium/device-activation/device-activation-tealium-service';

export type ApplicationContextType = {
  application: Application;
  dispatch: React.Dispatch<ApplicationAction>;
  salesforceService: ISalesforceService;
  feesService: IFeesService;
  children: React.ReactFragment;
  catalogue: Catalogue;
  bankDetailsValidationService: IBankDetailsValidationService;
  onboardingTealiumService: IOnboardingTealiumService;
  deviceActivationTealiumService: IDeviceActivationTealiumService;
};

// @ts-ignore
export const ApplicationContext = createContext<ApplicationContextType>({});

export function ApplicationProvider(props: ApplicationContextType) {
  return (
    <ApplicationContext.Provider value={{ ...props }}>{props.children}</ApplicationContext.Provider>
  );
}
